import { render, staticRenderFns } from "./LeadShow.vue?vue&type=template&id=1393961a"
import script from "./LeadShow.vue?vue&type=script&lang=js"
export * from "./LeadShow.vue?vue&type=script&lang=js"
import style0 from "./LeadShow.vue?vue&type=style&index=0&id=1393961a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports